<script>
import ItemIndex from "../../abstract/ItemIndex.js";
import scopeTitle from "../../mixins/survey/scopeTitle";

export default ItemIndex.extend({
  props: {
    isQuiz: {
      type: Boolean
    }
  },
  data() {
    return {
      options: {
        type: "all",
        my_surveys: true,
      },
      endpoint: "/api/surveys",
      sortColumn: "created_at",
      sortColumnDirection: "desc"
    };
  },
  mixins: [scopeTitle],
  methods: {
    getStatus(row) {
      let status = {
        badge: "is-transparent",
        text: ""
      };

      const inProgress = row.is_quiz && row.has_duration && this.$moment().isBefore(
        this.$moment(row.end_at).add(row.duration, "minutes")
      );

      if (row.participated) {
        if (row.is_quiz) {
          let score = _.get(row.current_session, "score", -1);
          let totalScore = _.get(row.current_session, "total_score", -1);
          let percentage = parseInt((score / totalScore) * 100);
          if (score > -1) {
            status.text = `${score} / ${totalScore} (${percentage}%)`;
            status.badge = "is-info";
          } else {
            status.text = "Ответы отправлены";
            status.badge = "is-success";
          }
        } else {
          status.text = "Отправлено";
          status.badge = "is-success";
        }
      } else {
        if (row.published) {
          if (row.active) {
            status.text = "Активно";
            status.badge = "is-danger";
          } else {
            if (row.is_quiz && row.participates) {
              status.text = "Время истекло";
              status.badge = "is-primary";
            } else {
              if (inProgress) {
                status.text = "В процессе";
                status.badge = "is-danger";
              } else {
                status.text = "Завершено";
                status.badge = "is-primary";
              }
            }
          }

          if (row.answers_submitted > -1 && !inProgress) {
            status.text += ` (${row.answers_submitted} ответов)`;
          }

          if (this.$moment().isBefore(row.start_at)) {
            status.text = "Начнётся " + this.$moment(row.start_at).fromNow();
            status.badge = "is-warning";
          }
        } else {
          status.text = "Не опубликовано";
          status.badge = "is-info";
        }
      }

      return status;
    },
    mergeOptions(options) {
      return _.merge(options, {
        is_quiz: this.isQuiz
      });
    },
    open: function(survey) {
      window.open(survey.url, "_self");
    },
    create() {
      let loading = this.$loading.open();

      let survey = {
        is_quiz: this.isQuiz
      };

      survey.title = survey.is_quiz ? "Новый тест" : "Новая анкета";

      axios
        .post("/api/surveys", survey)
        .then(response => {
          _.delay(() => {
            window.open(`${response.data.url}/edit`, "_self");
          }, 2000);
        })
        .catch(error => {
          loading.close();
          switch (error.response.status) {
            case 422: {
              let errors = error.response.data.errors;
              let key = _.first(_.keys(errors));
              this.toast("warning", _.first(errors[key]));
              break;
            }
            default: {
              this.modified = true;
              this.toast("error", "@unexpected", error);
              break;
            }
          }
        });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/surveys/Index.vue